import CardTabs, { ITabsItem } from 'modules/common/components/CardTabs';
import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type PropTypes = {
  items?: ITabsItem[];
};

const NavigationCardTabs: FC<PropTypes> = ({ items }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>(location.pathname);

  const onChangeTabs = (tabKey: string) => {
    navigate(tabKey);
  };

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  return (
    <CardTabs
      onChange={onChangeTabs}
      activeKey={activeTab}
      items={items || []}
    />
  );
};

export default NavigationCardTabs;
